var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntitiesTable',{attrs:{"config":_vm.config},scopedSlots:_vm._u([{key:"item.rateKey",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(("" + (_vm.$options.filters.capitalize(item.rateKey.replaceAll('_', ' ')))))+" ")]}},{key:"item.total",fn:function(ref){
var item = ref.item;
return [_vm._v(" $"+_vm._s(item.total)+" ")]}},{key:"item.sellRate",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.sellRate)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }